export var listenToVisibilityChange = function (handler) {
    document.addEventListener('visibilitychange', handler);
};
export var removeListenerForVisibilityChange = function (handler) {
    document.removeEventListener('visibilitychange', handler);
};
export var isDocumentVisible = function () { return document.visibilityState === 'visible'; };
//# sourceMappingURL=visibility-change.js.map